import { gql } from 'graphql-tag';
import { useMutation } from '@apollo/client';
import { BillStatus } from '~/types';

export const ISSUE_BILL = gql`
  mutation issueBill($input: IssueBillInput!) {
    issueBill(issueBillInput: $input) {
      success
      failedLineItems {
        project {
          id
          displayText
        }
        projectTCVAmount {
          amount
          currency {
            symbol
            displayText
          }
        }
        exceededBillAmount {
          amount
          currency {
            symbol
            displayText
          }
        }
      }
    }
  }
`;

export const useIssueBill = ({
  transactionId,
  updateDetails = false,
  refreshTransactionList = true,
  record
}) => {
  const [issueBill, { loading }] = useMutation(ISSUE_BILL);

  const refetchQueries = ['getBillingTransactionSummary'];

  if (refreshTransactionList)
    refetchQueries.push('getPageOfBillingTransactions');

  if (updateDetails)
    refetchQueries.push(
      'getBillDetails',
      'getBillLineItems',
      'getBillTaxLineItems'
    );

  return {
    issueBill: async syncBill => {
      const response = await issueBill({
        variables: {
          input: {
            invoiceId: transactionId,
            syncBill
          }
        },
        skip: record.billStatus === BillStatus.Billed,
        refetchQueries,
        awaitRefetchQueries: true
      });

      return { ...response.data };
    },
    loading
  };
};

export default useIssueBill;
